
import React from 'react';

interface LogoProps {
  className?: string;
  color?: 'black' | 'white';
}

const Logo: React.FC<LogoProps> = ({ className = '', color = 'black' }) => {
  const textColor = color === 'white' ? 'text-white' : 'text-black';
  
  return (
    <div className={`flex items-center ${className}`}>
      <div className="text-2xl md:text-3xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
        <span className={textColor}>Durbanville</span>
        <span className="text-[#e9f638] ml-2">PAINTERS</span>
      </div>
    </div>
  );
};

export default Logo;
